import React from 'react';
import Nav from 'react-bootstrap/Nav';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';

const SideBar = ({sections}) => {
    return (
        <Col xs={3}  style={{                    display: 'flex',
                    flexDirection: 'column', /* Stack card content vertically */
                    flexGrow: '1',
                    position: 'sticky',
                    bottom: '16rem',
                    alignSelf: 'flex-end',maxWidth: "240px"}}>   
                <Card> 
        <Nav justify variant="tabs"  className="flex-column" >
            {sections.map((section) => (
            <Nav.Item>
            <Nav.Link  href={'#' + section.sectionId}>
            {typeof section.title === 'string' ? section.title : section.title()}
            </Nav.Link>
        </Nav.Item>
            ))}
        </Nav>
        </Card></Col>
    );
}

export default SideBar